import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { OverviewSection } from "Components/Loyalty/Valor/OverviewSection";
import { ValorTabs } from "Components/Loyalty/Valor/ValorTabs";
import { isValidLoyaltyTab } from "Components/Loyalty/Shared/Tabs/config";
import { MooneLitePopup } from "Components/Dashboard/MooneLitePopup";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { useSearchParams } from "Navigation/useSearchParams";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

export const ValorPage = () => {
  const { t } = useResource();
  const { isUserInMooneLite } = useIsUserInMooneLite();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Valor)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("settings"),
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content" display="flex" flexDirection="column">
          {isUserInMooneLite ? <MooneLitePopup /> : <ValorPageContent />}
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

const ValorPageContent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("activeTab");
  const activeTab = isValidLoyaltyTab(tabParam) ? tabParam : "challenges";

  return (
    <Box display="flex" flexDirection="column" gap={3} p={3}>
      <OverviewSection />
      <ValorTabs
        initialTab={activeTab}
        onTabChange={(id) => setSearchParams({ activeTab: id })}
      />
    </Box>
  );
};
